/**
 * @license lucide-react v0.570.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createLucideIcon from '../createLucideIcon.js';

const __iconNode = [
  ["path", { d: "M11 6 8 9", key: "7zt14w" }],
  ["path", { d: "m16 7-8 8", key: "tkgtvu" }],
  ["rect", { x: "4", y: "2", width: "16", height: "20", rx: "2", key: "1uxh74" }]
];
const MirrorRectangular = createLucideIcon("mirror-rectangular", __iconNode);

export { __iconNode, MirrorRectangular as default };
//# sourceMappingURL=mirror-rectangular.js.map
